import React from "react";
import UITextField from "../UITextField";

const UITextarea = (props) => <UITextField multiline minRows={4} {...props} />;

export default UITextarea;
